import React from "react";
import { array } from "prop-types";

import NewsWithImage from "../../../../molecules/NewsWithImage";
import LeftImageRightNews from "../../../../molecules/LeftImageRightNews";

import "./organism3.m.css";

const Organism3 = ({ stories }) => {
  const firstStory = stories[0].story;
  const secondStory = stories.length > 1 ? stories[1].story : null;

  return (
    <div styleName="base" className="organism3-wrapper">
      <NewsWithImage story={firstStory} />
      {secondStory && <LeftImageRightNews story={secondStory} widths={[120]} />}
    </div>
  );
};

Organism3.propTypes = {
  stories: array.isRequired,
};

export default Organism3;
